module.exports = __webpack_public_path__ + "img/multiplier.300aa064.png";